package io.horion.cv.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Switch
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.widgets.*
import io.horion.cv.models.*
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@OptIn(DelicateApi::class)
@Composable
fun JobFormLayout2(
    state: Job,
    onStateChange: (Job) -> Unit
) {

    val breakpoint = rememberBreakpoint()

    Box(
        modifier = Modifier
            .fillMaxWidth(),
        contentAlignment = Alignment.TopCenter // ✅ centre horizontalement
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
              //  .maxWidth(1200.px)
                .margin(leftRight = 0.px)
                .padding(20.px),
            verticalArrangement = Arrangement.spacedBy(20.px)
        ) {

            //  MOBILE → tout en colonne
            if (breakpoint <= Breakpoint.MD) {

                //  CONTACT
                FormRow("Contact mail", breakpoint) {
                    TextFormFieldWhite(
                        value = state.contactEmail,
                        onValueChange = {newContact->
                            onStateChange(state.copy(contactEmail = newContact))
                        },
                        placeholder = "e-mail",
                    )
                }

                //  EXPERIENCE
                ExperienceForm(breakpoint, state, onStateChange)

                //  SALAIRE
                SalaryForm(state, onStateChange)

                //  REQUIREMENTS
                FormRow("Requierement", breakpoint) {
                    RequierementContent(
                    )
                }

                //  TAGS
                FormRow("Tags", breakpoint) {
                    TagsContent()
                }

            } else {

                // DESKTOP

                //  LIGNE 1 → CONTACT + EXPERIENCE
                Row(
                    modifier = Modifier.fillMaxWidth().gap(20.px),
                    horizontalArrangement = Arrangement.spacedBy(20.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {

                    Box(modifier = Modifier.flex(1)) {
                        ExperienceForm(
                            breakpoint = breakpoint,
                            state = state,
                            onStateChange = onStateChange
                        )
                    }
                    Box(modifier = Modifier.flex(1)) {
                        FormRow("Contact mail", breakpoint) {
                            TextFormFieldWhite(
                                value = state.contactEmail,
                                onValueChange = {mail->
                                    onStateChange(state.copy(contactEmail = mail))
                                },
                                placeholder = "e-mail",
                            )
                        }
                    }
                }

                // LIGNE 2 → SALAIRE (FULL WIDTH)
                SalaryForm(
                    state = state,
                    onStateChange = onStateChange
                )

                //  LIGNE 3 → REQUIREMENT + TAGS
                Row(
                    modifier = Modifier.fillMaxWidth().gap(10.px),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {

                    Box(modifier = Modifier.flex(1)) {
                        FormRow("Requierement", breakpoint) {
                            RequierementContent(

                            )
                        }
                    }

                    Box(modifier = Modifier.flex(1)) {
                        FormRow("Tags", breakpoint) {
                            TagsContent()
                        }
                    }
                }
            }
        }
    }
}



@Composable
fun ExperienceForm(
    breakpoint: Breakpoint,
    state: Job,
    onStateChange: (Job) -> Unit
) {
    var selectedExperienceLevels by remember { mutableStateOf(listOf<ExperienceLevel>()) }

    FormRow("Niveau d'expérience", breakpoint) {
        FilterCheckGroup(
            title = "",
            items = ExperienceLevel.values().toList(),
            checkedItems = selectedExperienceLevels,
            onCheckedChange = { item, isChecked ->
                selectedExperienceLevels =
                    if (isChecked) selectedExperienceLevels + item
                    else selectedExperienceLevels - item
            },
            label = {
                when (it) {
                    ExperienceLevel.JUNIOR -> "Junior"
                    ExperienceLevel.MID -> "Intermédiaire"
                    ExperienceLevel.SENIOR -> "Senior"
                    ExperienceLevel.EXPERT -> "Expert"
                }
            },
            breakpoint = breakpoint
        )
    }
}

@OptIn(DelicateApi::class)
@Composable
fun SalaryForm(
    state: Job,
    onStateChange: (Job) -> Unit
) {

    val breakpoint = rememberBreakpoint()

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .borderRadius(12.px)
            .padding(20.px),
        verticalArrangement = Arrangement.spacedBy(16.px)
    ) {

        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            SpanText("Salaire", Modifier.fontWeight(FontWeight.Bold))

            Row(verticalAlignment = Alignment.CenterVertically) {
                Switch(
                    checked = state.isRemote,
                    onCheckedChange = {remote->
                        onStateChange(state.copy(isRemote = remote))
                    }
                )
                SpanText("Discutable", Modifier.margin(left = 8.px))
            }
        }

        if (breakpoint <= Breakpoint.SM) {

            Column(verticalArrangement = Arrangement.spacedBy(10.px)) {

                FormRow("Minimal :", breakpoint) {
                    IntFormField(
                        value = state.salaryRange.min,
                        min = 0,
                        max = state.salaryRange.max,
                        placeholder = "Min",
                        onValueChange = {min->
                            onStateChange(state.copy(
                                salaryRange = state.salaryRange.copy(min = min ?: 0)
                            ))
                        }
                    )
                }

                FormRow("Maximal :", breakpoint) {
                    IntFormField(
                        value = state.salaryRange.max,
                        min = state.salaryRange.min,
                        max = 10_000_000,
                        placeholder = "Max",
                        onValueChange = {max->
                            onStateChange(state.copy(
                                salaryRange = state.salaryRange.copy(max = max ?: 0)
                            ))
                        }
                    )
                }

                FormRow("Devise :", breakpoint) {
                    TextFormFieldWhite(
                        value = state.salaryRange.currency,
                        onValueChange = {currency->
                            onStateChange(state.copy(
                                salaryRange = state.salaryRange.copy(currency = currency )
                            ))},
                        placeholder = "FCFA"
                    )
                }
            }

        } else {

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .border(1.px, LineStyle.Solid, Colors.LightGray)
                    .borderRadius(10.px)
                    .padding(15.px),
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ) {

                FormRow("Minimal :", breakpoint) {
                    IntFormField(
                        value = state.salaryRange.min,
                        min = 0,
                        max = state.salaryRange.max,
                        placeholder = "Min",
                        onValueChange = {min->
                            onStateChange(state.copy(
                                salaryRange = state.salaryRange.copy(min = min ?: 0)
                            ))}
                    )
                }

                FormRow("Maximal :", breakpoint) {
                    IntFormField(
                        value = state.salaryRange.max,
                        min = state.salaryRange.min,
                        max = 10_000_000,
                        placeholder = "Max",
                        onValueChange = { max->
                            onStateChange(state.copy(
                                salaryRange = state.salaryRange.copy(max = max ?: 0)
                            ))
                        }
                    )
                }

                FormRow("Devise :", breakpoint) {
                    TextFormFieldWhite(
                        value = state.salaryRange.currency,
                        onValueChange = { devise ->
                            onStateChange(
                                state.copy(
                                    salaryRange = state.salaryRange.copy(currency = devise)
                                )
                            )
                        },
                        placeholder = "FCFA"
                    )
                }
            }
        }
    }
}